const state = {
  CropID: null,
  // dodati provjeru ako je selektirano voće dodaj 1 po defaultu
  CropStageID: null,
  Yield: null,
  Surface: null,
  YieldUnitId: 8,
  SurfaceUnitId: 2,
  SelectedFertilizersOnStages: []
};

const getters = {
  cropID: state => {
    return state.CropID;
  },
  cropStageId: state => {
    return state.CropStageID;
  },
  yield: state => {
    return state.Yield;
  },
  surface: state => {
    return state.Surface;
  },
  yieldUnitId: state => {
    return state.YieldUnitId;
  },
  surfaceUnitId: state => {
    return state.SurfaceUnitId;
  },
  selectedFertilizersOnStages: state => {
    return state.SelectedFertilizersOnStages;
  }
};

const mutations = {
  // Default input parameters
  UpdateCropID: (state, payload) => {
    state.CropID = payload;
  },
  UpdateCropStageID: (state, payload) => {
    state.CropStageID = payload;
  },
  UpdateYield: (state, payload) => {
    state.Yield = payload;
  },
  UpdateSurface: (state, payload) => {
    state.Surface = payload;
  },
  UpdateYieldUnitId: (state, payload) => {
    state.YieldUnitId = payload;
  },
  UpdateSurfaceUnitId: (state, payload) => {
    state.SurfaceUnitId = payload;
  },
  UpdateSelectedFertilizersOnStages: (state, payload) => {
    state.SelectedFertilizersOnStages = payload;
  }
};

const actions = {
  UpdateCropID ({ commit }, payload) {
    commit('UpdateCropID', payload);
  },
  UpdateCropStageID ({ commit }, payload) {
    commit('UpdateCropStageID', payload);
  },
  UpdateYield ({ commit }, payload) {
    commit('UpdateYield', payload);
  },
  UpdateYieldUnitId ({ commit }, payload) {
    commit('UpdateYieldUnitId', payload);
  },
  UpdateSurface ({ commit }, payload) {
    commit('UpdateSurface', payload);
  },
  UpdateSurfaceUnitId ({ commit }, payload) {
    commit('UpdateSurfaceUnitId', payload);
  },
  UpdateSelectedFertilizersOnStages ({ commit }, payload) {
    commit('UpdateSelectedFertilizersOnStages', payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
